// Used in core.module.ts

// Angular
import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";

// Services/Types/Helpers
import { TechCheckService } from "#services/tech-check.service";
import { Language } from "cli-types";

// Validators
import { EmailValidator } from "#validators/email.validator";
import { LanguageService, SupportRequest, SupportResponse, SupportService } from "@carnegie-learning/data-access-angular-passport";

@Component({
    selector: "support",
    templateUrl: "./support.component.html",
    styleUrls: ["./support.component.scss"],
    standalone: false
})
export class SupportComponent implements OnInit {
    supportForm = this.fb.group({
        name: ["", [Validators.required]],
        email: ["", [Validators.required, EmailValidator.email]],
        phone: ["", [Validators.pattern("^[0-9]{3}-[0-9]{3}-[0-9]{4}$")]],
        role: ["", [Validators.required]],
        district: ["", [Validators.required]],
        school: ["", [Validators.required]],
        language: ["", [Validators.required]],
        course: [""],
        teacher: [""],
        description: ["", [Validators.required]],
    });

    roles: string[] = ["District Admin", "School Admin", "Student", "Teacher"];

    languages: Language[];
    response: SupportResponse;
    errors: any;
    clientInfo: any;
    formFlag = true;
    sendingFlag = false;

    constructor(
        private fb: UntypedFormBuilder,
        private router: Router,
        private languageService: LanguageService,
        public techCheck: TechCheckService,
        public supportService: SupportService
    ) {
        this.clientInfo = this.techCheck.getTechInfo();
    }

    ngOnInit() {
        this.languageService.publicLanguages().subscribe(
            (data) => {
                this.languages = data;
            },
            (error) => {
                this.errors = error;
            }
        );
    }

    // TODO update with print error
    validate(field: string, type: string) {
        return (
            this.supportForm.get(field)?.touched &&
            this.supportForm.get(field)?.hasError(type)
        );
    }

    goBack() {
        return this.router.navigate(["login/form"]);
    }

    submit(): void {
        const payload: SupportRequest = {
            browser: this.clientInfo.browser.name,
            courseName: this.supportForm.value.course,
            districtName: this.supportForm.value.district,
            email: this.supportForm.value.email,
            flashPlayer: this.clientInfo.flash.name,
            issueDescription: this.supportForm.value.description,
            language: this.supportForm.value.language,
            loggedIn: false,
            name: this.supportForm.value.name,
            os: this.clientInfo.os.name,
            phone: this.supportForm.value.phone,
            schoolName: this.supportForm.value.school,
            screenResolution: this.clientInfo.screenResolution.name,
            teacherName: this.supportForm.value.teacher,
            type: this.supportForm.value.role,
        };

        this.sendingFlag = true;
        this.formFlag = false;

        this.supportService.send(payload).subscribe(
            (response) => {
                this.response = response;
                this.sendingFlag = false;
            },
            (error) => {
                this.errors = error;
                this.sendingFlag = false;
            }
        );
    }
}
